import TraceEvent from "../../../../contents/docs/llm-analytics/_snippets/trace-event.mdx";
import * as React from 'react';
export default {
  TraceEvent,
  React
};